export enum ColumnSizesEnum {
    Col1 = 'col-md-1',
    Col2 = 'col-md-2',
    Col3 = 'col-md-3',
    Col4 = 'col-md-4',
    Col5 = 'col-md-5',
    Col6 = 'col-md-6',
    Col7 = 'col-md-7',
    Col8 = 'col-md-8',
    Col9 = 'col-md-9',
    Col0 = 'col-md-10',
    Col11 = 'col-md-11',
    Col12 = 'col-md-12'
}
